// extracted by mini-css-extract-plugin
module.exports = {"container":"submitButton_container__2iyc3","text":"submitButton_text__3mYgB"};